export default "__VITE_ASSET__BeETqDuu__"